import React from "react";
import { Outlet, useLocation } from "react-router-dom";

const AuthFeature = () => {
  const location = useLocation();
  const layoutPages = location.pathname === "/coming-soon" ||location.pathname === "/under-maintenance" ||location.pathname === "/under-construction";
  // Páginas que ocupam a tela inteira e não querem o wrapper de auth em volta.
  // `/contas` é o shell do multi-conta: o layout vem de dentro de cada frame.
  const isLoginPage =
    location.pathname === "/entrar" || location.pathname === "/contas";

  if (isLoginPage) {
    return <Outlet />;
  }

  return (
    <div className={`bg-linear-gradiant ${layoutPages ? "d-flex align-items-center justify-content-center" : ""}`}>
      <div className="main-wrapper">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthFeature;
